<script lang="ts">
	import { camera_previews } from 'src/stores/features/cameras/previews';
	import {
		getCameraPreviewUrl,
		isSingleCameraLiveFeedEnabled,
	} from 'src/components/Dashboards/dash-camera-helpers';
	import type { DashCameraWidgetConfig } from 'src/components/Dashboards/dash-types';
	import type { Device } from 'src/types/Device';
	import type { DeviceSettingsG2 } from 'src/types/DeviceSettings';
	import type { DeviceStatusG2 } from 'src/types/DeviceStatusG2';
	import DashCameraDeviceCard from './DashCameraDeviceCard.svelte';

	type AdditionalText = {
		value: string;
		icon?: string;
		type?: 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'muted';
	};

	export let variant: 'button' | 'quick-control' = 'button';
	export let cameraConfig: DashCameraWidgetConfig | undefined;
	export let value: string;
	export let additionalText: AdditionalText | undefined;
	export let editMode = false;
	export let device: Device | undefined;
	export let status: DeviceStatusG2 | undefined;
	export let settings: DeviceSettingsG2 | undefined;
	export let offline = false;
	export let selected = false;
	export let showFullscreen = false;

	let cameraPreviewImage = '';

	$: useLiveFeed = !editMode && isSingleCameraLiveFeedEnabled(device?.id, cameraConfig);
	$: if ($camera_previews && device?.id) {
		getCameraPreviewUrl(device.id).then((url) => (cameraPreviewImage = url));
	} else {
		cameraPreviewImage = '';
	}

	$: isQuickControl = variant === 'quick-control';
	$: ariaLabel = isQuickControl ? 'Dash Camera Parameter Widget' : 'Dash Camera Button Widget';
	$: arrowRight = !editMode;
</script>

<DashCameraDeviceCard
	aria-label={ariaLabel}
	isFocusable={!editMode}
	{value}
	{additionalText}
	previewImage={cameraPreviewImage}
	imageFit="cover"
	{useLiveFeed}
	showLiveIndicator={useLiveFeed && !offline}
	{offline}
	{selected}
	{editMode}
	{arrowRight}
	{showFullscreen}
	hideRightTitleSlot={isQuickControl}
	{device}
	{status}
	{settings}
	useCloudConnectionIcon
	on:click
	on:arrow-click
	on:fullscreen
	on:handle-drag-start
	on:handle-drag-end
/>
